import React from "react";
import { cn } from "./cn";

type Padding = "none" | "sm" | "md";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  as?: "div" | "section" | "article";
  padding?: Padding;
};

const paddings: Record<Padding, string> = {
  none: "",
  sm: "p-3",
  md: "p-5",
};

const Card: React.FC<Props> = ({
  as: Tag = "div",
  padding = "none",
  className,
  ...rest
}) => (
  <Tag
    className={cn(
      "rounded-2xl border border-gray-200 bg-white shadow-sm",
      paddings[padding],
      className,
    )}
    {...rest}
  />
);

export default Card;
